import "./WebsiteDesign.module.css";
import Header from "@/reusable_sections/Header";
import Optimization from "./sections/Optimization";
import Performance from "./sections/Performance";
import Benefits from "./sections/Benefits";
import StrategyCall from "./sections/StrategyCall";
import WhyItMatters from "./sections/WhyItMatters";
import FaqAccordion from "./sections/FaqAccordion";
import Stepper from "./sections/Stepper";
import Footer from "@/reusable_sections/Footer";
export default function WebsiteDesignPage() {
  return <div>
      <Header />
      <Optimization />
      <Performance />
      <Benefits />
      <StrategyCall />
      <WhyItMatters />
      <FaqAccordion />
      <Stepper />
      <Footer />
    </div>;
}